<div class="p-6 max-h-[85vh] overflow-auto">
  <h2 mat-dialog-title class="text-xl font-semibold mb-2">BOQ Bidding Deviation Report</h2>

  <div *ngIf="data?.invitation" class="mb-4 p-3 bg-gray-50 rounded-lg">
    <p class="text-sm text-gray-600">
      <strong>Project:</strong> {{ data.invitation.project_name }} |
      <strong>BOQ:</strong> {{ data.invitation.boq_code }} - {{ data.invitation.boq_name }}
    </p>
  </div>

  <div *ngIf="data?.summary" class="mb-4 p-3 bg-amber-50 rounded-lg border border-amber-200">
    <p class="text-sm font-medium text-amber-800">Total deviations: {{ data.summary.total_deviations }}</p>
    <p *ngIf="data.summary.by_bidder" class="text-xs text-amber-700 mt-1">
      <ng-container *ngFor="let entry of data.summary.by_bidder | keyvalue">{{ entry.key }}: {{ entry.value }}; </ng-container>
    </p>
  </div>

  <div *ngIf="!data?.deviations?.length" class="py-8 text-center text-gray-500">
    <mat-icon class="text-5xl mb-2">check_circle</mat-icon>
    <p>No deviations - all bidder quantities and rates match the estimated BOQ</p>
  </div>

  <div *ngIf="data?.deviations?.length" class="overflow-x-auto">
    <table class="w-full text-sm">
      <thead>
        <tr class="border-b bg-gray-50">
          <th class="text-left py-2 px-2">Item</th>
          <th class="text-right py-2 px-2">Est. Qty</th>
          <th class="text-right py-2 px-2">Est. Rate</th>
          <th class="text-right py-2 px-2">Bid Qty</th>
          <th class="text-right py-2 px-2">Bid Rate</th>
          <th class="text-right py-2 px-2">Deviation</th>
          <th class="text-left py-2 px-2">Bidder</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let d of data.deviations" class="border-b hover:bg-gray-50">
          <td class="py-2 px-2">{{ d.item_code }}</td>
          <td class="py-2 px-2 text-right">{{ d.estimated_quantity }}</td>
          <td class="py-2 px-2 text-right">{{ formatCurrency(d.estimated_unit_rate) }}</td>
          <td class="py-2 px-2 text-right">{{ d.bidder_quantity }}</td>
          <td class="py-2 px-2 text-right">{{ formatCurrency(d.bidder_unit_rate) }}</td>
          <td class="py-2 px-2 text-right">
            <span class="inline-flex items-center gap-1" [ngClass]="getDeviationClass(getDeviationAmount(d))">
              <mat-icon *ngIf="getDeviationAmount(d) > 0" class="text-base align-middle">arrow_downward</mat-icon>
              <mat-icon *ngIf="getDeviationAmount(d) < 0" class="text-base align-middle">arrow_upward</mat-icon>
              {{ formatCurrency(getDeviationAmount(d)) }}
            </span>
          </td>
          <td class="py-2 px-2">{{ d.bidder_org_name }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div mat-dialog-actions class="flex justify-end pt-4">
    <button mat-raised-button (click)="onClose()">Close</button>
  </div>
</div>
